import { render, staticRenderFns } from "./SPDuplicateDialog.vue?vue&type=template&id=541a17d2&"
import script from "./SPDuplicateDialog.vue?vue&type=script&lang=ts&"
export * from "./SPDuplicateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports